/* eslint-disable id-length */
/* eslint-disable sort-keys */
const i18n = {
	reOrgReceptionPerson: {
		1 : "Лицо проводившее приём",
		0 : "Асоба, якая праводзіла прыём"
	},
	reOrgReceptionPersonPlaceholder: {
		1 : "Выберите лицо, проводившее прием",
		0 : "Абярыце асобу, якая праводзіла прыём"
	},
	eventDate: {
		1 : "Дата мероприятия",
		0 : "Дата мерапрыемства"
	},
	forbiddenBack: {
		1 : "Вернуться",
		0 : "Вярнуцца"
	},
	forbidden: {
		1 : "Нет доступа",
		0 : "Няма доступу"
	},
	isRequired: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	},
	save: {
		1 : "Сохранить",
		0 : "Захаваць"
	},
	cancel: {
		1 : "Отменить",
		0 : "Адмяніць"
	},
	downloadAppeal: {
		1 : "Скачать обращение",
		0 : "Спампаваць зварот"
	},
	exportAppeal: {
		1 : "Экспортировать обращение",
		0 : "Экспартаваць зварот"
	},
	chooseTemplate: {
		1 : "Выбрать шаблон",
		0 : "Выбраць шаблон"
	},
	appealsYou: {
		1 : "Список поданных вами обращений",
		0 : "Спіс пададзеных вамі зваротаў"
	},
	appointYou: {
		1 : "Список назначенных на вас обращений",
		0 : "Спіс прызначаных на вас зваротаў"
	},
	appealsIn: {
		1 : "Список поданных в организацию обращений",
		0 : "Спіс пададзеных у арганізацыю зваротаў"
	},
	appealsControl: {
		1 : "Список обращений на контроле организации",
		0 : "Спіс зваротаў на кантролі арганізацыі"
	},
	appealToControl: {
		1 : "Обращение на контроле в: ",
		0 : "Зварот на кантролі ў: "
	},
	case: {
		1 : "Дело",
		0 : "Справа"
	},
	appeal: {
		1 : "Обращение",
		0 : "Зварот"
	},
	typeOfCollectAppeal: {
		1 : "Тип коллективного обращения",
		0 : "Тып калектыўнага звароту"
	},
	closeCollectAppeal: {
		1 : "Закрытое",
		0 : "Закрытае"
	},
	openCollectAppeal: {
		1 : "Открытое",
		0 : "Адкрытае"
	},
	formedCollectAppeal: {
		1 : "Сформированное",
		0 : "Сфарміраванае"
	},

	themeOgul: {
		1 : "Тема обращения",
		0 : "Тэма звароту"
	},
	appealInfo: {
		1 : "Информация по обращению",
		0 : "Інфармацыя па звароце"
	},
	subThemeOgul: {
		1 : "Подтема обращения",
		0 : "Падтэма звароту"
	},
	responceExecutor: {
		1 : "Ответственный исполнитель",
		0 : "Адказны выканаўца" 
	},
	reOrgAppeal: {
		1 : "Организация, которая рассматривает данное обращение",
		0 : "Арганізацыя, якая разглядае дадзены зварот"
	},
	reOrgAppeals: {
		1 : "Организации, в которые подано обращение",
		0 : "Арганізацыі, у якія пададзен зварот"
	},
	personalUser: {
		1 : "Должность лица, которому направляется обращение",
		0 : "Пасада асобы, якому накіроўваецца зварот"
	},
	appealsCollective: {
		1 : 'Список незавершённых коллективных',
		0 : 'Спіс незавершаных калектыўных'
	},
	resolutionChangeHistory: {
		1 : "История работы с резолюциями",
		0 : "Гісторыя працы з рэзалюцыямі"
	},
	content: {
		1 : 'Содержание обращения',
		0 : 'Змест звароту'
	},
	appealFiles: {
		1 : 'Прикреплённые файлы',
		0 : 'Прымацаваныя файлы'
	},
	aplicantType: {
		1 : 'Категория заявителя',
		0 : 'Катэгорыя заяўніка'
	},
	aplicantTypeNameFiz: {
		1 : 'Физическое лицо',
		0 : 'Фізічная асоба'
	},
	aplicantTypeNameYur: {
		1 : 'Юридическое  лицо',
		0 : 'Юрыдычная асоба'
	},
	address: {
		1 : 'Адрес',
		0 : 'Адрас'
	},
	fio: {
		1 : 'ФИО',
		0 : 'Прозвішча'
	},
	applicantInfo: {
		1 : 'Данные заявителя',
		0 : 'Дадзеныя заяўніка'
	},
	orgName: {
		1 : 'Наименование организации',
		0 : 'Найменне арганізацыі'
	},
	fio: {
		1 : "ФИО заявителя",
		0 : "Прозвішча заяўніка"
	},
	orgUNP: {
		1 : 'УНП организации',
		0 : 'УНП арганізацыі'
	},
	appealFormTitle: {
		1 : 'Подача обращения',
		0 : 'Падача звароту'
	},
	appealOrgFormTitle: {
		1 : 'Создание РКК',
		0 : 'Стварэнне РКК'
	},
	appealOrgEditFormTitle: {
		1 : 'Редактирование РКК',
		0 : 'Рэдагаванне РКК'
	},
	appealFormUserTypeField: {
		1 : 'Категория заявителя',
		0 : 'Катэгорыя заяўніка'
	},
	appealFormUserTypeLabel: {
		1 : 'Выберите категорию заявителя',
		0 : 'Выберыце катэгорыю заяўніка'
	},
	themeOgulLabel: {
		1 : 'Выберите тему обращения',
		0 : 'Выберыце тэму звароту'
	},
	subThemeOgulLabel: {
		1 : 'Выберите тему обращения',
		0 : 'Выберыце падтэму звароту'
	},
	appealFormReOrgSelectTitle: {
		1 : 'Выберите организацию',
		0 : 'Выберыце арганізацыю'
	},
	appealFormReOrgReceiverSelectTitle: {
		1 : 'Выберите организацию-получателя',
		0 : 'Абярыце арганізацыю-атрымальніка'
	},
	appealFormIsPersonalTitle: {
		1 : 'Обращение является личным?',
		0 : 'Зварот з\'яўляецца асабістым?'
	},
	personalUserTitle: {
		1 : 'Должность лица, которому направляется обращение',
		0 : 'Пасада асобы, якому накіроўваецца зварот'
	},
	appealViewTypeTitle: {
		1 : 'Выберите вид обращения',
		0 : 'Выберыце від звароту'
	},
	yes: {
		1 : 'Да',
		0 : 'Так'
	},
	no: {
		1 : 'Нет',
		0 : 'Не'
	},
	notInSocGroup: {
		1 : 'Не имею социальной категории',
		0 : 'Не маю сацыяльнай катэгорыі'
	},
	isComplaintOnOrganization: {
		1 : 'Жалоба на организацию',
		0 : 'Скарга на арганізацыю'
	},
	isComplaintOnOrganizationTitle: {
		1 : 'Можно подать жалобу на определённую организацию',
		0 : 'Можна падаць скаргу на пэўную арганізацыю'
	},
	complaintOnOrganization: {
		1 : 'Выберите организацию по жалобе',
		0 : 'Выберыце арганізацыю па скарзе'
	},
	complaintOnOrganizationTitle: {
		1 : 'Начните вводить наименование организациию',
		0 : 'Пачніце ўводзіць назву арганізацыі'
	},
	ComplaintPerson: {
		1 : 'ФИО лица, на которого подаётся жалоба',
		0 : 'Прозвішча, імя асобы, на якога падаецца скарга'
	},
	individual: {
		1 : 'Индивидуальное',
		0 : 'Iндывідуальны'
	},
	collective: {
		1 : 'Коллективное',
		0 : 'Калектыўны'
	},
	isPrivate: {
		1 : 'Обращение является открытым',
		0 : 'Зварот з\'яўляецца адкрытым'
	},
	showMarkTitle: {
		1 : "Необходимо добавить файл",
		0 : "Неабходна дадаць файл"
	},

	isPrivateTitle: {
		1 : 'Присоединение к открытому обращению будет доступно для всех пользователей, а закрытое доступно только для выбранных Вами пользователям.',
		0 : 'Далучэнне да адкрытага звароту будзе даступна для ўсіх карыстальнікаў, а закрытае даступна толькі для выбраных вамі карыстальнікам.'
	},
	answers: {
		1 : 'Дополнительные формы ответа',
		0 : 'Дадатковыя формы адказу'
	},
	emailAnswer: {
		1 : 'По электронному  адресу',
		0 : 'Па электронным адрасе'
	},
	writtenAnswer: {
		1 : 'По почтовому адресу',
		0 : 'Па паштовым адрасе'
	},
	sendAppealButton: {
		1 : 'Подать обращение',
		0 : 'Падаць зварот'
	},
	update : {
		1 : 'Обновить запись',
		0 : 'Абнавіць запіс'
	},
	lastName: {
		1 : 'Фамилия',
		0 : 'Прозвішча'
	},
	firstName: {
		1 : 'Имя',
		0 : 'Імя'
	},
	middleName: {
		1 : 'Отчество',
		0 : 'Імя па бацьку'
	},
	address: {
		1 : "Адрес",
		0 : "Адрас"
	},
	email: {
		1 : 'Электронная почта',
		0 : 'Электронная пошта'
	},
	orgName: {
		1 : "Наименование организации",
		0 : "Найменне арганізацыі"
	},
	orgType: {
		1 : 'Тип организации',
		0 : 'Тып арганізацыі'
	},
	orgAddress: {
		1 : 'Адрес организации',
		0 : 'Адрас арганізацыі'
	},
	position: {
		1 : 'Должность',
		0 : 'Пасада'
	},
	ApplicantPhone: {
		1 : 'Контактный телефон',
		0 : 'Кантактны тэлефон'
	},
	ApplicantUserType: {
		1 : 'Статус физического лица',
		0 : 'Статус фізічнай асобы'
	},
	ApplicantIdentificationNumber: {
		1 : 'Идентификационный номер',
		0 : 'Ідэнтыфікацыйны нумар'
	},
	ApplicantReSocialGroupType: {
		1 : 'Категория гражданина (социальная)',
		0 : 'Катэгорыя грамадзяніна (сацыяльная)'
	},
	yurFIOdescription: {
		1 : 'Фамилия, имя, отчество, должность лица, уполномоченного в установленном порядке подписывать обращения',
		0 : 'Прозвішча, імя, імя па бацьку, пасада асобы, упаўнаважанай ва ўстаноўленым парадку падпісваць звароты'
	},
	yurFIOdescriptionView: {
		1 : 'ФИО уполномоченного лица',
		0 : 'Прозвишча ўпаўнаважанага асобы'
	},
	emailAnswerView: {
		1 : 'Нужен ответ на электронный адрес',
		0 : 'Патрэбен адказ на электронны адрас'
	},
	writtenAnswerView: {
		1 : 'Нужен ответ по почтовому адресу',
		0 : 'Патрэбен адказ па паштовым адрасе'
	},
	downloadPackage: {
		1 : 'Загрузить шаблон конверта',
		0 : 'Загрузіць шаблон канверта'
	},
	OrgCreator: {
		1 : 'Организация заявитель',
		0 : 'Арганізацыя заяўнік'
	},
	ListRepeatAppeals: {
		1 : 'Список повторных обращений',
		0 : 'Спіс паўторных зваротаў'
	},
	RedirectAppeals: {
		1 : 'Перенаправление обращения',
		0 : 'Перанакіраванне звароту'
	},
	RegisterDate: {
		1 : 'Дата регистрации обращения',
		0 : 'Дата рэгістрацыі звароту'
	},
	FIOPosition: {
		1 : 'Ответственный руководитель',
		0 : 'Адказны кіраўнік'
	},
	yurFIOdescriptionCreateAppeal: {
		1 : 'Фамилия, имя, отчество заявителя',
		0 : 'Прозвішча, імя, імя па бацьку заяўніка'
	},
	ReFormTypes: {
		1 : 'Форма подачи',
		0 : 'Форма падачы'
	},
	ReFormTypesLabel: {
		1 : 'Выберите форму подачи',
		0 : 'Выберыце тып звароту'
	},
	ApplicantEmail: {
		1 : 'Электронная почта заявителя',
		0 : 'Электронная пошта заяўніка'
	},
	BriefSummary: {
		1 : 'Краткое содержание обращения',
		0 : 'Кароткі змест звароту'
	},
	BriefSummaryError: {
		1 : 'Превышено максимальное число символов',
		0 : 'Перавышана максімальная колькасць сімвалаў'
	},
	BriefSummaryWhitespaceError: {
		1 : 'Краткое содержание не может состоять только из знаков пробела!',
		0 : 'Кароткі змест не можа складацца толькі са знакаў прабелу!'
	},
	IsRepetitionTitle: {
		1 : 'Обращение является повторным. Количество повторов',
		0 : 'Зварот з\'яўляецца паўторным. Колькасць паўтораў'
	},
	PreviousAppealLinkTitle: {
		1 : 'Предыдущее обращение',
		0 : 'Папярэдні зварот'
	},
	IsRepetition: {
		1 : 'Повторное обращение',
		0 : 'Паўторны зварот'
	},
	OrgRegNumber: {
		1 : 'Регистрационный номер в СЭД',
		0 : 'Рэгістрацыйны нумар у СЭД'
	},
	openAppeal: {
		1 : 'Открыть карточку',
		0 : 'Адкрыць картку'
	},
	open: {
		1 : 'Открыть',
		0 : 'Адкрыць'
	},
	registerAppeal: {
		1 : 'Зарегистрировать',
		0 : 'Зарэгістраваць'
	},
	recallAppeal: {
		1 : 'Отозвать',
		0 : 'Адклікаць'
	},
	successRecallAppeal: {
		1 : 'Обращение было успешно отозвано',
		0 : 'Зварот быў паспяхова адкліканы'
	},
	leaveWithoutConsiderationAppeal: {
		1 : 'Оставить без рассмотрения',
		0 : 'Пакінуць без разгляду'
	},
	leaveWithoutConsiderationHeader: {
		1 : 'Введите причину',
		0 : 'Увядзіце прычыну'
	},
	successChangeAppealStatus: {
		1 : 'Статус обращения успешно изменён!',
		0 : 'Статус звароту паспяхова зменены!'
	},
	leaveWithoutConsiderationRequierd: {
		1 : 'Необходимо указать причину!',
		0 : 'Неабходна ўказаць прычыну!'
	},
	leaveWithoutConsiderationPlaceholder: {
		1 : 'Начните вводить причину',
		0 : 'Пачніце ўводзіць прычыну'
	},
	ReviewProcess: {
		1 : 'Процесс рассмотрения обращения',
		0 : 'Працэс разгляду звароту'
	},
	ReviewProcessRequired: {
		1 : 'Пожалуйста, введите процесс рассмотрения обращения!',
		0 : 'Калі ласка, увядзіце працэс разгляду звароту!'
	},
	ReviewProcessPlaceholder: {
		1 : 'Начните вводить процесс рассмотрения обращения',
		0 : 'Пачніце ўводзіць працэс разгляду звароту'
	},
	ReviewResult: {
		1 : 'Результат рассмотрения обращения',
		0 : 'Вынік разгляду звароту'
	},
	ReviewResultSigner: {
		1 : 'Результат рассмотрения обращения подписал',
		0 : 'Вынік разгляду звароту падпісаў'
	},
	AppealSignInfo: {
		1 : 'Подпись заявителя',
		0 : 'Подпіс заяўніка'
	},
	ReOrgAppealSignInfo: {
		1 : 'Подпись ответственного лица',
		0 : 'Подпіс адказнай асобы'
	},
	ReviewResultPlaceholder: {
		1 : 'Начните вводить результат рассмотрения обращения',
		0 : 'Пачніце ўводзіць вынік разгляду звароту'
	},
	ReviewResultRequierd: {
		1 : 'Пожалуйста, введите результат рассмотрения обращения!',
		0 : 'Калі ласка, увядзіце вынік разгляду звароту!'
	},
	AppealIsEnd: {
		1 : 'Обращение исполнено',
		0 : 'Зварот выкананы'
	},
	AppealEndWithoutConsideration: {
		1 : 'Оставить обращение без рассмотрения по существу',
		0 : 'Пакінуць зварот без разгляду па сутнасці'
	},
	AppealEndDate: {
		1 : 'Дата завершения рассмотрения обращения',
		0 : 'Дата завяршэння разгляду звароту'
	},
	ResponseSendDate: {
		1 : 'Дата направления ответа заявителю',
		0 : 'Дата напрамкі адказу заяўніку'
	},
	WithoutConsiderationReason: {
		1 : 'Причина оставления обращения без рассмотрения по существу',
		0 : 'Прычына пакідання звароту без разгляду па сутнасці'
	},
	CaseNumber: {
		1 : 'Номер сформированного дела',
		0 : 'Нумар сфармаванай справы'
	},
	CaseNumberPlaceholder: {
		1 : 'Начните вводить номер дела',
		0 : 'Пачніце ўводзіць нумар справы'
	},
	CaseNumberRequierd: {
		1 : 'Пожалуйста, введите номер сформированного дела!',
		0 : 'Калі ласка, увядзіце нумар сфармаванай справы!'
	},
	AnswerRegNumber: {
		1 : 'Регистрационный номер ответа',
		0 : 'Рэгістрацыйны нумар адказу'
	},
	RegNumber: {
		1 : 'Регистрационный номер в СЭД',
		0 : 'Рэгістрацыйны нумар у СЭД'
	},
	AnswerRegNumberPlaceholder: {
		1 : 'Начните вводить номер ответа',
		0 : 'Пачніце ўводзіць нумар адказу'
	},
	AnswerRegNumberRequierd: {
		1 : 'Пожалуйста, введите регистрационный номер ответа!',
		0 : 'Калі ласка, увядзіце рэгістрацыйны нумар адказу!'
	},
	ReAnswerForm: {
		1 : 'Формы отправки ответа заявителю',
		0 : 'Формы адпраўкі адказу заяўніку'
	},
	HandledByHead: {
		1 : 'Обращение заполнено руководителем',
		0 : 'Зварот запоўнены кіраўніком'
	},
	PreviousAppeal: {
		1 : 'Предыдущее обращение',
		0 : 'Папярэдні зварот'
	},
	PreviousAppealPlaceHolder: {
		1 : 'Введите регистрационный номер предыдущего обращения',
		0 : 'Увядзіце рэгістрацыйны нумар папярэдняга звароту'
	},

	appealViewType: {
		1 : "Вид обращения",
		0 : "Выгляд звароту"
	},
	appealType: {
		1 : "Тип обращения",
		0 : "Тып звароту"
	},
	content: {
		1 : "Содержание обращения",
		0 : "Змест звароту"
	},
	briefSummary: {
		1 : "Краткое содержание обращения",
		0 : "Кароткі змест звароту"
	},
	aplicantType: {
		1 : "Категория заявителя",
		0 : "Катэгорыя заяўніка"
	},
	aplicantTypeNameFiz: {
		1 : "Физическое лицо",
		0 : "Фізічная асоба"
	},
	aplicantTypeNameYur: {
		1 : "Юридическое  лицо",
		0 : "Юрыдычная асоба"
	},
	address: {
		1 : "Адрес",
		0 : "Адрас"
	},
	fio: {
		1 : "ФИО",
		0 : "Прозвішча"
	},
	applicantInfo: {
		1 : "Данные заявителя",
		0 : "Дадзеныя заяўніка"
	},
	responseForms: {
		1 : "Форма ответа",
		0 : "Форма адказу"
	},
	appealDecision: {
		1 : "Решение по обращению",
		0 : "Рашэнне па звароце"
	},
	appealDecisionPlaceholder: {
		1 : "Выберите решение по обращению",
		0 : "Абярыце рашэнне па звароце"
	},
	orgName: {
		1 : "Наименование организации",
		0 : "Найменне арганізацыі"
	},
	fio: {
		1 : "ФИО заявителя",
		0 : "Прозвішча заяўніка"
	},
	orgUNP: {
		1 : "УНП организации",
		0 : "УНП арганізацыі"
	},
	appealFormTitle: {
		1 : "Подача обращения",
		0 : "Падача звароту"
	},
	appealFormUserTypeField: {
		1 : "Категория заявителя",
		0 : "Катэгорыя заяўніка"
	},
	appealFormUserTypeLabel: {
		1 : "Выберите категорию заявителя",
		0 : "Выберыце катэгорыю заяўніка"
	},
	themeOgulLabel: {
		1 : "Выберите тему обращения",
		0 : "Выберыце тэму звароту"
	},
	subThemeOgulLabel: {
		1 : "Выберите тему обращения",
		0 : "Выберыце падтэму звароту"
	},
	appealFormReOrgSelectTitle: {
		1 : "Выберите организацию",
		0 : "Выберыце арганізацыю"
	},
	appealFormReOrgsSelectTitle: {
		1 : "Выберите организации",
		0 : "Выберыце арганізацыі"
	},
	appealFormReOrgSelectPlaceholder: {
		1 : "Начните вводить название организации",
		0 : "Пачніце ўводзіць назву арганізацыі"
	},
	appealFormIsPersonalTitle: {
		1 : "Персональное обращение",
		0 : "Персанальны зварот"
	},
	appealFormIsPersonalDescription: {
		1 : "Выберите, если хотите подать обращение конкретному должностному лицу",
		0 : "Выберыце, калі вы хочаце падаць зварот канкрэтнаму службовай асобе"
	},
	appealFormIsPersonalDescription: {
		1 : "Если этот пункт выбран, то обращение будет направлено конкретному работнику организации",
		0 : "Калі гэты пункт абраны, то зварот будзе накіраваны канкрэтнаму работніку арганізацыі"
	},
	appealViewTypeTitle: {
		1 : "Выберите вид обращения",
		0 : "Выберыце від звароту"
	},
	yes: {
		1 : "Да",
		0 : "Так"
	},
	no: {
		1 : "Нет",
		0 : "Не"
	},
	notInSocGroup: {
		1 : "Не имею социальной категории",
		0 : "Не маю сацыяльнай катэгорыі"
	},
	isComplaintOnOrganization: {
		1 : "Жалоба на организацию",
		0 : "Скарга на арганізацыю"
	},
	isComplaintOnOrganizationTitle: {
		1 : "Выберите, если хотите подать жалобу на организацию",
		0 : "Выберыце, калі хочаце падаць скаргу на арганізацыю"
	},
	complaintOnOrganization: {
		1 : "Выберите организацию на которую подаётся жалоба",
		0 : "Выберыце арганізацыю на якую падаецца скарга"
	},
	complaintOnOrganizationTitle: {
		1 : "Начните вводить наименование организациию",
		0 : "Пачніце ўводзіць назву арганізацыі"
	},
	individual: {
		1 : "Индивидуальное",
		0 : "Iндывідуальны"
	},
	collective: {
		1 : "Коллективное",
		0 : "Калектыўны"
	},
	collectivePlaceholder: {
		1 : "Для подачи коллективного обращения в системе необходимо при его формировании выбрать соответствующий вид обращения, заполнить предусмотренные поля, а для внесения сведений о каждом участнике коллектива заявителей (фамилия, собственное имя и отчество (если таковое имеется), адрес места жительства (пребывания), личная подпись и иная необходимая информация) необходимо к обращению прикрепить сканированный файл, содержащий такую информацию.",
		0 : "Для падачы калектыўнага звароту ў сістэме неабходна пры яго фарміраванні выбраць адпаведны від звароту, запоўніць прадугледжаныя палі, а для ўнясення звестак аб кожным удзельніку калектыву заяўнікаў (прозвішча, уласнае імя і імя па бацьку (калі такое маецца), адрас месца жыхарства (знаходжання), асабісты подпіс і іншая неабходная інфармацыя) неабходна да звароту прымацаваць сканаваны файл, які змяшчае такую інфармацыю."
	},
	formedTypeTitle: {
		1 : "При выборе сформированного сообщения обязательно прикрепление файла с подписями.",
		0 : "Пры выбары сфармаванага паведамлення абавязкова прымацаванне файла з подпісамі. "
	},
	appealIs: {
		1 : "Обращение является",
		0 : "Зварот з'яўляецца"
	},
	appealIsTitle: {
		1 : "Присоединение к открытому обращению будет доступно для всех пользователей, а закрытое доступно только по ссылке. Для сформированного обращения необходимо добавить файл с подписями.",
		0 : "Далучэнне да адкрытага звароту будзе даступна для ўсіх карыстальнікаў, а закрытае даступна толькі па спасылцы. Для сфармаванага звароту неабходна дадаць файл з подпісамі."

	},
	formedType: {
		1 : "Сформированным",
		0 : "Сфармаваным"
	},
	openType: {
		1 : "Открытым",
		0 : "Адкрытым"
	},
	openTypeTitle: {
		1 : "Присоединение к открытому обращению будет доступно для всех пользователей.",
		0 : "Далучэнне да адкрытага звароту будзе даступна для ўсіх карыстальнікаў."
	},
	closeType: {
		1 : "Закрытым",
		0 : "Закрытым"
	},
	closeTypeTitle: {
		1 : "Присоединение к закрытому обращению будет доступно только по ссылке.",
		0 : "Далучэнне да закрытаго звароту будзе даступна толькі па спасылцы."
	},
	isPrivate: {
		1 : "Обращение является открытым",
		0 : "Зварот з'яўляецца адкрытым"
	},
	isPrivateTitle: {
		1 : "Присоединение к открытому обращению будет доступно для всех пользователей, а закрытое доступно только по ссылке.",
		0 : "Далучэнне да адкрытага звароту будзе даступна для ўсіх карыстальнікаў, а закрытае даступна толькі па спасылцы."
	},
	answers: {
		1 : "Форма ответа",
		0 : "Форма адказу"
	},
	emailAnswer: {
		1 : "По электронному  адресу",
		0 : "Па электронным адрасе"
	},
	writtenAnswer: {
		1 : "По почтовому адресу",
		0 : "Па паштовым адрасе"
	},
	sendAppealButton: {
		1 : "Подать обращение",
		0 : "Падаць зварот"
	},
	sendOrgAppealButton: {
		1 : "Создать",
		0 : "Стварыць"
	},
	editOrgAppealButton: {
		1 : "Редактировать",
		0 : "Рэдагаваць"
	},
	lastName: {
		1 : "Фамилия",
		0 : "Прозвішча"
	},
	lastNameRequired: {
		1 : `Поле "Фамилия" должно быть заполнено!`,
		0 : `Поле "Прозвішча" должно быть заполнено!`
	},
	firstName: {
		1 : "Имя",
		0 : "Імя"
	},
	firstNameRequired: {
		1 : "Поле 'Имя' обязательно для заполнения.",
		0 : "Поле 'Імя' абавязкова для запаўнення."
	},
	lastNameRequiredWithWidthLimit: {
		1 : "Пожалуйста, введите Фамилию! (длина строки {0})",
		0 : "Калі ласка, увядзіце Прозвішча! (даўжыня радка {0})"
	},
	firstNameRequiredWithWidthLimit: {
		1 : "Пожалуйста, введите Имя! (длина строки {0})",
		0 : "Калі ласка, увядзіце Імя! (даўжыня радка {0})"
	},
	emailRequired: {
		1 : "Пожалуйста, введите действующий адрес электронной почты!",
		0 : "Калі ласка, увядзіце дзейны адрас электроннай пошты!"
	},
	WithoutConsiderationReasonRequired: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	},
	middleName: {
		1 : "Отчество",
		0 : "Імя па бацьку"
	},
	address: {
		1 : "Адрес",
		0 : "Адрас"
	},
	email: {
		1 : "Электронная почта",
		0 : "Электронная пошта"
	},
	orgName: {
		1 : "Наименование организации",
		0 : "Найменне арганізацыі"
	},
	orgType: {
		1 : "Тип организации",
		0 : "Тып арганізацыі"
	},
	orgAddress: {
		1 : "Адрес организации",
		0 : "Адрас арганізацыі"
	},
	position: {
		1 : "Должность",
		0 : "Пасада"
	},
	ApplicantPhone: {
		1 : "Контактный телефон",
		0 : "Кантактны тэлефон"
	},
	ApplicantUserType: {
		1 : "Статус физического лица",
		0 : "Статус фізічнай асобы"
	},
	ApplicantIdentificationNumber: {
		1 : "Идентификационный номер",
		0 : "Ідэнтыфікацыйны нумар"
	},
	ApplicantReSocialGroupType: {
		1 : "Категория гражданина (социальная)",
		0 : "Катэгорыя грамадзяніна (сацыяльная)"
	},
	yurFIOdescription: {
		1 : "Фамилия, имя, отчество, должность лица, уполномоченного в установленном порядке подписывать обращения",
		0 : "Прозвішча, імя, імя па бацьку, пасада асобы, упаўнаважанай ва ўстаноўленым парадку падпісваць звароты"
	},
	yurFIOdescriptionView: {
		1 : "ФИО уполномоченного лица",
		0 : "Прозвишча ўпаўнаважанага асобы"
	},
	emailAnswerView: {
		1 : "Необходим ответ на электронный адрес",
		0 : "Неабходны адказ на электронны адрас"
	},
	writtenAnswerView: {
		1 : "Необходим ответ по почтовому адресу",
		0 : "Неабходны адказ па паштовым адрасе"
	},
	redirectAppeal: {
		1 : "Перенаправить обращение",
		0 : "Перанакіраваць зварот"
	},
	redirectRAs: {
		1 : "Состояния перенаправления",
		0 : "Стану перасылак"
	},
	createResolution: {
		1 : "Создать резолюцию",
		0 : "Стварыць рэзалюцыю"
	},
	editResolution: {
		1 : "Редактировать резолюцию",
		0 : "Рэдагаваць рэзалюцыю"
	},
	signResolutionTitle: {
		1 : "Подписать резолюцию",
		0 : "Падпісаць рэзалюцыю"
	},
	signResolution: {
		1 : "Подписать",
		0 : "Падпісаць"
	},
	createResolutionWithSigner: {
		1 : "Создать проект резолюции",
		0 : "Стварыць праект рэзалюцыі"
	},
	editResolutionWithSigner: {
		1 : "Редактировать проект резолюции",
		0 : "Рэдагаваць праект рэзалюцыі"
	},
	ecpResolution: {
		1 : "Прикрепить ЭЦП к резолюции?",
		0 : "Прымацаваць ЭЛП да рэзалюцыі?"
	},
	resolutions: {
		1 : "Резолюции",
		0 : "Рэзалюцыі"
	},
	executor: {
		1 : "Исполняющий",
		0 : "Выконваючы"
	},
	changeExecutor: {
		1 : "Изменить исполнителя",
		0 : "Памяняць выканаўца"
	},
	appealExecutorSelectTitle: {
		1 : "Выберите ответственного руководителя",
		0 : "Выберыце адказнага кіраўніка"
	},
	appealExecutorSelectTitle2: {
		1 : "Выберите исполнителей",
		0 : "Выберыце выканаўцаў"
	},
	appealExecutorManager: {
		1 : "Выберите ответственного исполнителя",
		0 : "Выберыце адказнага выканаўцу"
	},
	appealExecutorSigner: {
		1 : "Выберите ответственного руководителя",
		0 : "Выберыце адказнага кіраўніка"
	},
	appealExecutorSelect: {
		1 : "Выберите ответственного руководителя",
		0 : "Выберыце адказнага кіраўніка"
	},
	minPrevAppeal: {
		1 : "Минимум 3 символа!",
		0 : "Мінімум 3 сімвала!"
	},
	isOutsideRB: {
		1 : "Подача из-за пределов Республики Беларусь",
		0 : "Падача з-за межаў Рэспублікі Беларусь"
	},
	wrongEmail: {
		1 : "Неправильный адрес электронной почты",
		0 : "Няправільны адрас электроннай пошты"
	},
	noReportText: {
		1 : "Текст отчёта обязателен к заполнению!",
		0 : "Тэкст справаздачы абавязковы да запаўнення!"
	},
	requiredRule: {
		1 : 'Поле "${label}" должно быть заполнено!',
		0 : 'Поле "${label}" павінна быць запоўнена!'
	},
	wrongUserForEdit: {
		1 : "У Вас нет прав для редактирования этого обращения",
		0 : "У Вас няма правоў для рэдагавання гэтага звароту "
	},
	successCreateAppeal: {
		1 : "Обращение успешно создано!",
		0 : "Зварот паспяхова створаны!"
	},
	successEditAppeal: {
		1 : "Обращение успешно отредактировано!",
		0 : "Зварот паспяхова адрэдагаваны!"
	},
	successCreateResolution: {
		1 : "Резолюция успешно создана!",
		0 : "Рэзалюцыя паспяхова створана!"
	},
	successSignResolution: {
		1 : "Резолюция успешно подписана!",
		0 : "Рэзалюцыя паспяхова падпісана!"
	},
	successSaveResolution: {
		1 : "Резолюция успешно обновлена!",
		0 : "Рэзалюцыя паспяхова абноўлена!"
	},
	successDeclineResolution: {
		1 : "Проект резолюции отклонен!",
		0 : "Праект рэзалюцыі адхілены!"
	},
	successAddExecutorFiles: {
		1 : "Файл(ы) успешно добавлен(ы)!",
		0 : "Файл(ы) паспяхова дададзены!"
	},
	succesDeleteExecutorFiles: {
		1 : "Файл успешно удалён.",
		0 : "Файл паспяхова выдалены."
	},
	successAddResponceExecutorFiles: {
		1 : "Файл(ы) успешно добавлен(ы)!\nЧтобы продолжить, нажмите кнопку 'Сохранить'",
		0 : "Файл(ы) паспяхова дададзены!\nКаб працягнуць, націсніце кнопку 'Захаваць'"
	},
	addFiles: {
		1 : "Добавить файл",
		0 : "Дадаць файл"
	},
	openFiles: {
		1 : "Открыть файлы",
		0 : "Адкрыць файлы"
	},
	successFinalise: {
		1 : "Обращение успешно завершено!",
		0 : "Зварот паспяхова завершан!"
	},
	appealGetStatusOnControl: {
		1 : "Обращение получило статус на контроле.",
		0 : "Зварот атрымаў статус на кантролі" 
	},
	successCreateAppealDescription: {
		1 : "Отслеживать статус обращения возможно в личном кабинете.",
		0 : "Адсочваць статус звароту магчыма ў асабістым кабінеце."
	},
	errorCreateAppeal: {
		1 : "Обращение не создано!",
		0 : "Зварот не створан!"
	},
	errorEditAppeal: {
		1 : "Обращение не отредактировано!",
		0 : "Зварот не адрэдагаван!"
	},
	errorCreateResolution: {
		1 : "Резолюция не создана!",
		0 : "Рэзалюцыя не створана!"
	},
	errorSignResolution: {
		1 : "Резолюция не подписана!",
		0 : "Рэзалюцыя не падпісана!"
	},
	errorSaveResolution: {
		1 : "Резолюция не обновлена!",
		0 : "Рэзалюцыя не абноўлена!"
	},
	errorDeclineResolution: {
		1 : "Проект резолюции не отклонен!",
		0 : "Проект рэзалюцыі не адхілены!"
	},
	errorFinalise: {
		1 : "Обращение не завершено!",
		0 : "Зварот не завершан!"
	},
	errorCreateAppealDescription: {
		1 : "Попробуйте ещё раз или обратитесь к администратору со скриншотом данной ошибки.",
		0 : "Паспрабуйце яшчэ раз, або звярніцеся да адміністратара з скрыншоце дадзенай памылкі."
	},
	appealFormError: {
		1 : "Ошибка подачи обращения",
		0 : "Памылка падачы звароту"
	},
	СollectiveAppealFormError: {
		1 : "Добавьте как минимум одного участника обращения",
		0 : "Дадайце як мінімум аднаго удзельніка звароту"
	},
	appealFormErrorDescription: {
		1 : "Заполните обязательные поля!",
		0 : "Запоўніце абавязковыя палі!"
	},
	anonymous: {
		1 : "Анонимное",
		0 : "Ананімны"
	},
	finaliseAppeal: {
		1 : "Завершить процесс рассмотрения обращения",
		0 : "Завяршыць працэс разгляду звароту"
	},
	editReviewProcess: {
		1 : "Дополнить процесс рассмотрения обращения",
		0 : "Дапоўніць працэс разгляду звароту"
	},
	sendMessageToApplicant: {
		1 : "Отправить сообщение заявителю",
		0 : "Адправіць паведамленне заяўніку"
	},
	sendMessageToExecutor: {
		1 : "Отправить сообщение исполнителю",
		0 : "Адправіць паведамленне выканаўцу"
	},
	sendMessagePlaceholder: {
		1 : "Пожалуйста, введите текст сообщения.",
		0 : "Калі ласка, увядзіце тэкст паведамлення."
	},
	sendMessageSuccess: {
		1 : "Сообщение успешно отправлено!",
		0 : "Паведамленне паспяхова дасланы!"
	},
	resolutionExecutors: {
		1 : "Исполнители резолюции",
		0 : "Выканаўцы рэзалюцыі"
	},
	resolutionIssuer: {
		1 : "Сотрудник, назначивший резолюцию",
		0 : "Супрацоўнік, якi назначыў рэзалюцыю"
	},
	resolutionExecutor: {
		1 : "Исполнитель резолюции",
		0 : "Выканавец рэзалюцыі"
	},
	resolutionStartDate: {
		1 : "Дата назначения резолюции",
		0 : "Дата прызначэння рэзалюцыі"
	},
	resolutionEndDueDate: {
		1 : "Срок исполнения резолюции",
		0 : "Тэрмін выканання рэзалюцыі"
	},
	resolutionEndDate: {
		1 : "Дата исполнения резолюции",
		0 : "Дата выканання рэзалюцыі"
	},
	resolutionContent: {
		1 : "Содержание резолюции",
		0 : "Змест рэзалюцыі"
	},
	resolutionExecutionResult: {
		1 : "Ответ",
		0 : "Адказ"
	},
	partlyRedirectAppeal: {
		1 : "Перенаправить часть вопросов:",
		0 : "Перанакіраваць частку пытанняў:"
	},
	parentRedirectAppeal: {
		1 : "Перенаправить в подведомственную/дочернюю организацию:",
		0 : "Перанакіраваць у падведамную/даччыную арганізацыю:"
	},
	onlyParentRedirectAppeal: {
		1 : "Возможность постановки на контроль доступна только при перенаправлении в дочернюю/подведомственную организацию",
		0 : "Магчымасць пастаноўкі на кантроль даступная толькі пры перанакіраванні ў даччыную/падведамную арганізацыю"
	},
	contolHigher: {
		1 : "Поставить на контроль:",
		0 : "Паставіць на кантроль:"
	},
	reOrgRequired: {
		1 : "Необходимо выбрать организацию!",
		0 : "Неабходна выбраць арганізацыю!"
	},
	reOrgSearchPlaceholder: {
		1 : "Начните вводить название или УНП организации",
		0 : "Пачніце ўводзіць назву або УНП арганізацыі"
	},
	reOrgSearchNotFound: {
		1 : "Организации не найдены",
		0 : "Арганізацыі не знойдзеныя"
	},
	regNumber: {
		1 : "Регистрационный номер сопроводительного письма",
		0 : "Рэгістрацыйны нумар суправаджальнага ліста"
	},
	regNumberPlaceholder: {
		1 : "Начните вводить регистрационный номер",
		0 : "Пачніце ўводзіць рэгістрацыйны нумар"
	},
	regNumberRequired: {
		1 : "Необходимо написать регистрационный номер!",
		0 : "Неабходна напісаць рэгістрацыйны нумар!"
	},
	transmittalLetter: {
		1 : "Сопроводительное письмо",
		0 : "Суправаджальны ліст"
	},
	transmittalLetterPlaceholder: {
		1 : "Начните вводить сопроводительное письмо",
		0 : "Пачніце ўводзіць суправаджальны ліст"
	},
	transmittalLetterRequired: {
		1 : "Необходимо написать сопроводительное письмо!",
		0 : "Неабходна напісаць суправаджальны ліст!"
	},
	notifyToApplicant: {
		1 : "Уведомление для заявителя",
		0 : "Апавяшчэнне для заяўніка"
	},
	notifyToApplicantPlaceholder: {
		1 : "Начните вводить уведомление для заявителя",
		0 : "Пачніце ўводзіць апавяшчэнне для заяўніка"
	},
	notifyToApplicantRequired: {
		1 : "Необходимо написать уведомление для заявителя!",
		0 : "Неабходна напісаць апавяшчэнне для заяўніка!"
	},
	noticeToRework: {
		1 : "Причины доработки",
		0 : "Прычыны дапрацоўкі"
	},
	noticeToReworkPlaceholder: {
		1 : "Начните вводить причины доработки",
		0 : "Пачніце ўводзіць прычыны дапрацоўкі"
	},
	noticeToReworkRequired: {
		1 : "Необходимо написать причины доработки!",
		0 : "Неабходна напісаць прычыны дапрацоўкі!"
	},
	attachFilesTransmittal: {
		1 : "Файлы к сопроводительному письму",
		0 : "Файлы да суправаджальнага ліста"
	},
	attachFilesApplicant: {
		1 : "Файлы к уведомлению для заявителя",
		0 : "Файлы да апавяшчэння для заяўніка"
	},
	filesPlaceholder: {
		1: `Не более 5 файлов. 
        Доступные форматы: ".jpg", "jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".rtf".
        Размер файла должен быть до {0}МБ`,
		0: `Не больш за 5 файлаў.
        Даступныя фарматы: ".jpg", "jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".tif", ".tiff", ".rtf".
        Памер файла павінен быць да {0}МБ`
	},
	filesMaxCountErrorNotice: {
		1: "Нельзя добавлять больше {0} файлов!",
		0: "Нельга дадаваць больш {0} файлаў!"
	},
	fileTypeError: {
		1 : "Недоступный формат файла",
		0 : "Недаступны фармат файла"
	},
	downloadFileSizeError: {
		1 : "Размер файла больше {0}МБ",
		0 : "Памер файла больш {0}МБ"
	},
	attachFilesTitle: {
		1 : "Прикрепление файлов",
		0 : "Прымацаванне файлаў"
	},
	isRedirect: {
		1 : "Обращение успешно перенаправлено в {0}!",
		0 : "Зварот паспяхова перанакіраваны ў {0}!"
	},
	isRedirected: {
		1 : "Обращение успешно перенаправлено!",
		0 : "Зварот паспяхова перанакіраваны!"
	},
	isNotRedirect: {
		1 : ["Обращение не перенаправлено в {0}", "Данная организация уже рассматривает данное обращение."],
		0 : ["Зварот не перанакіраваны ў {0}", "Гэтая арганізацыя ўжо разглядае гэты зварот."]
	},
	creatorRedirectAppealForm: {
		1 : "Создатель формы перенаправления",
		0 : "Стваральнік формы перанакіравання"
	},
	receiverRedirectAppealForm: {
		1 : "Получатель формы перенаправления",
		0 : "Атрымальнік формы перанакіравання"
	},
	redirectDateForm: {
		1 : "Дата перенаправления",
		0 : "Дата перанакіравання"
	},
	formReceiverTooltip: {
		1 : "Руководитель организации/заместитель руководителя, перенаправление которому будет направлено на подписание",
		0 : "Кіраўнік арганізацыі/намеснік кіраўніка, перанакіраванне якому будзе накіравана на падпісанне"
	},
	formReceiverRule: {
		1 : "Необходимо выбрать получателя формы перенаправления!",
		0 : "Неабходна выбраць атрымальніка формы перанакіравання!"
	},
	appealTransferForms: {
		1 : "Формы перенаправления обращения",
		0 : "Формы перанакіравання звароту"
	},
	formToReceive: {
		1 : "Отправить на подписание",
		0 : "Адправіць на падпісанне"
	},
	formToRequest: {
		1 : "Направить запрос",
		0 : "Накіраваць запыт"
	},
	formRequestHeader: {
		1 : "Упрощённый запрос",
		0 : "Спрошчаны запыт"
	},
	formRequestItems: {
		1 : ["Текст запроса", "Прикрепить файлы к запросу"],
		0 : ["Тэкст запыту", "Прымацаваць файлы да запыту"]
	},
	formRequestItemsRequired: {
		1 : ["Введите текст запроса (если отсутствуют файлы)!", "Прикрепите файлы (если отсутствует текст запроса)!"],
		0 : ["Увядзіце тэкст запыту (калі адсутнічаюць файлы)!", "Прымацуеце файлы (калі адсутнічае тэкст запыту)!"]
	},
	successRequest: {
		1 : "Запрос успешно направлен!",
		0 : "Запыт паспяхова накіраваны!"
	},
	appealRequestForms: {
		1 : "Запросы в ГО",
		0 : "Запыты ў ДО"
	},
	emptyAppealRequestForms: {
		1 : "Данные о запросах в ГО касательно обращения отсутствуют.",
		0 : "Дадзеныя аб запытах у ДО датычна звароту адсутнічаюць."
	},
	searchAppealRequestForms: {
		1 : "Подождите, идёт поиск данных о запросах в ГО касательно обращения...",
		0 : "Пачакайце, ідзе пошук дадзеных аб запытах у ДО датычна звароту..."
	},
	titleAppealRequestForm: {
		1 : ["Запрос в ", " от "],
		0 : ["Запыт у ", " ад "]
	},
	appealRequestFormItems: {
		1: [
			"Дата отправки запроса",
			"Получатель запроса",
			"Содержание запроса",
			"Файлы запроса",
			"Дата ответа на запрос",
			"Содержание ответа на запрос",
			"Файлы ответа на запрос"
		],
		0: [
			"Дата адпраўкі запыту",
			"Атрымальнік запыту",
			"Змест запыту",
			"Файлы запыту",
			"Дата адказу на запыт",
			"Змест адказу на запыт",
			"Файлы адказу на запыт"
		]
	},
	formToRework: {
		1 : "Отправить на доработку",
		0 : "Адправіць на дапрацоўку"
	},
	isCreateRedirectForm: {
		1 : "Форма перенапаправления успешно отправлена на подписание!",
		0 : "Форма перанакіравання паспяхова адпраўлена на падпісанне!"
	},
	emptyRedirectAppealForms: {
		1 : "Данные о формах перенаправления для подписания отсутствуют.",
		0 : "Дадзеныя аб формах перанакіравання для падпісання адсутнічаюць."
	},
	searchRedirectAppealForms: {
		1 : "Подождите, идёт поиск данных о формах перенаправления для подписания...",
		0 : "Пачакайце, ідзе пошук дадзеных аб формах перанакіравання для падпісання..."
	},
	titleRedirectAppealForm: {
		1 : "Форма перенаправления для подписания от ",
		0 : "Форма перанакіравання для падпісання ад "
	},
	IsIdentical: {
		1 : "Идентичное обращение",
		0 : "Ідэнтычны зварот"
	},
	JoininkTitle: {
		1 : "Ссылка для присоединения к обращению",
		0 : "Спасылка для далучэння да звароту"
	},
	InviteUserTitle: {
		1 : "Приглашение пользователей присоединиться к обращению",
		0 : "Запрашэнне карыстальнікаў далучыцца да звароту"
	},
	InputUserLoginPlaceholder: {
		1 : "Введите логин пользователя",
		0 : "Увядзіце лагін карыстальніка"
	},
	InputUserLoginAlert: {
		1 : "Вам необходимо ввести логин пользователя, которого хотите пригласить присоединиться к обращению.",
		0 : "Вам неабходна ўвесці лагін карыстальніка, якога хочаце запрасіць далучыцца да звароту."
	},
	CollectiveLinkDescription: {
		1 : "Cсылка для присоединеия к обращению:",
		0 : "Спасылка для далучэння да звароту:"
	},
	InviteUserButton: {
		1 : "Пригласить пользователя",
		0 : "Запрасіць карыстальніка"
	},
	CollectiveAppealUsersTitle: {
		1 : "Присоединённые пользователи",
		0 : "Далучаныя карыстальнікі"
	},
	InvitedAppealUsersTitle: {
		1 : "Приглашенные пользователи",
		0 : "Запрошаныя карыстальнікі"
	},
	SubmitedAppeal: {
		1 : "Обращение ещё НЕ находится в обработке, для этого необходимо подтвердить подачу обращения:",
		0 : "Зварот яшчэ НЕ знаходзіцца ў апрацоўцы, для гэтага неабходна пацвердзіць падачу звароту"
	},
	SubmitedAppealManage: {
		1 : "Управление обращением",
		0 : "Кіраванне зваротам"
	},
	SubmitedAppealButton: {
		1 : "Подтвердить подачу обращения",
		0 : "Пацвердзіць падачу звароту"
	},
	SubmitedAppealConfirm: {
		1 : "Вы уверены, что хотите подтвердить подачу обращения? После подачи к нему нельзя будет присоединиться.",
		0 : "Вы ўпэўненыя, што хочаце пацвердзіць падачу звароту? Пасля падачы да яго нельга будзе далучыцца."
	},
	JoinAppealHeader: {
		1 : "Присоединение к обращению",
		0 : "Далучэнне да звароту"
	},
	JoinAppealTitle: {
		1 : "Форма присоединения к обращению",
		0 : "Форма далучэння да звароту"
	},
	JoinAppeaButton: {
		1 : "Присоединиться к обращению",
		0 : "Далучыцца да звароту"
	},
	JoinAppealConfirm: {
		1 : "Вы уверены, что хотите присоединиться к обращению?",
		0 : "Вы ўпэўненыя, што хочаце далучыцца да звароту?"
	},
	ErrorJoin: {
		1 : "Вы уже присоединились к данному обращению",
		0 : "Вы ўжо далучыліся да дадзенага звароту"
	},
	ErrorJoinToPrivateAppeal: {
		1 : "У вас нет приглашения для присоединения к данному коллективному обращению.",
		0 : "У вас няма запрашэння для далучэння да дадзенага калектыўнага звароту."
	},
	ErrorJoinUserIsNull: {
		1 : "Для присоединения к коллективному обращению вам необходимо пройти авторизацию.",
		0 : "Для далучэння да калектыўнага звароту вам неабходна прайсці аўтарызацыю."
	},
	EndDataInvite: {
		1 : "Обращение уже было подано. Присоединиться к данному обращению больше невозможно.",
		0 : "Зварот ужо быў пададзены. Далучыцца да гэтага звароту больш немагчыма."
	},
	noAccessToAppeal: {
		1 : "У вас нет прав для управлением данным обращением.",
		0 : "У вас няма правоў для кіраваннем дадзеным зваротам."
	},
	ErrorResponseJoin: {
		1 : "Вы уже ответили на данное приглашение",
		0 : "Вы ўжо адказалі на гэтае запрашэнне"
	},
	JoinAppealRequestTitle: {
		1 : "Хотите присоединиться к обращению?",
		0 : "Хочаце далучыцца да звароту?"
	},
	JoinAppealDecline: {
		1 : "Вы уверены, что хотите отказаться от присоединения к обращению?",
		0 : "Вы ўпэўненыя, што хочаце адмовіцца ад далучэння да звароту?"
	},
	DeclineButton: {
		1 : "Отказаться",
		0 : "Адмовіцца"
	},
	AddAppealButton: {
		1 : "Вы уверены, что хотите подать обращение?",
		0 : "Вы ўпэўненыя, што хочаце падаць зварот?"
	},
	AppealCreateSaveButtonConfirm: {
		1 : "Вы уверены, что хотите создать обращение?",
		0 : "Вы ўпэўненыя, што хочаце стварыць зварот?"
	},
	DownloadWithAdminNumber: {
		1 : "Добавить к конверту строку 'ПРАВИТЕЛЬСТВЕННОЕ'?",
		0 : "Дадаць да канверта радок 'ПРАВИТЕЛЬСТВЕННОЕ'?"
	},
	AppealCreateEditButtonConfirm: {
		1 : "Вы уверены, что хотите редактировать это обращение?",
		0 : "Вы ўпэўненыя, што хочаце рэдагаваць гэты зварот?"
	},
	collectiveModal: {
		1 : "Вы выбрали коллективное обращение. Оно ещё НЕ было отправлено в выбранные организации. Вы можете направить обращение в организацию после того, как наберётся удовлетворяющее вас количество добавленных к обращению пользователей.",
		0 : "Вы выбралі калектыўны зварот. Яно яшчэ НЕ было адпраўлена ў выбраныя арганізацыі. Вы можаце накіраваць зварот у арганізацыю пасля таго, як набярэцца задавальняе вас колькасць дададзеных да звароту карыстальнікаў."
	},
	createError: {
		1 : "Попробуйте ещё раз или обратитесь к администратору со скриншотом данной ошибки.",
		0 : "Паспрабуйце яшчэ раз, або звярніцеся да адміністратара з скрыншоце дадзенай памылкі."
	},
	createSuccess: {
		1 : "Отслеживать статус Вашего обращения возможно в личном кабинете.",
		0 : "Адсочваць статус Вашага звароту магчыма ў асабістым кабінеце."
	},
	joinToAppealSuccess: {
		1 : "Вы успешно присоединились к данному обращению!",
		0 : "Вы паспяхова далучыліся да гэтага звароту!"
	},
	joinToAppealError: {
		1 : "Ошибка присоединения к обращению!",
		0 : "Памылка далучэння да звароту!"
	},
	reOrgSelectHelper: {
		1 : "Начните вводить один из параметров: наименование организации, краткое наименование организации или УНП. Поиск начинается с четырёх символов",
		0 : "Пачніце ўводзіць адзін з параметраў: найменне арганізацыі, кароткае найменне арганізацыі або УНП. Пошук пачынаецца з чатырох знакаў"
	},
	CollectiveAppealUserAddButton: {
		1 : "Добавить участника обращения",
		0 : "Дадаць ўдзельніка звароту"
	},
	ErrorLessThenTwoPeolpeInCollectiveAppeal: {
		1 : "Невозможно подтвердить подачу коллективного обращения, так как в нём состоит меньше двух человек.",
		0 : "Немагчыма пацвердзіць падачу калектыўнага звароту, так як у ім складаецца менш двух чалавек."
	},
	InviteMyselfToAppealError: {
		1 : "Нельзя пригласить самого себя!",
		0 : "Нельга запрасіць самога сябе!"
	},
	SuccessAppealSubmit: {
		1 : "Вы успешно подали данное обращение!",
		0 : "Вы паспяхова падалі дадзены зварот!"
	},
	SuccessUserInvite: {
		1 : "Пользователь успешно приглашён!",
		0 : "Карыстальнік паспяхова запрошаны!"
	},
	pleaseInput: {
		1 : "Введите",
		0 : "Увядіце"
	},
	chooseTemplate: {
		1 : "Выберите шаблон",
		0 : "Выберыце шаблон"
	},
	correspondenceTerminated: {
		1 : "Переписка по данному вопросу прекращена",
		0 : "Перапіска па гэтым пытанні спыненая"
	},
	missing: {
		1 : "Отсутствует",
		0 : "Адсутнічае"
	},
	IsCorrespondenceTerminated: {
		1 : "Переписка по данному вопросу прекращена",
		0 : "Перапіска па гэтым пытанні спыненая "
	},
	addEcpWCAppeal: {
		1 : 'Прикрепить ЭЦП к обращению?',
		0 : 'Прымацаваць ЭЛП да звароту?'
	},
	sendDataToBelpochtaSystem: {
		1 : "Передавать информацию в НПЭС",
		0 : "Перадаваць інфармацыю ў НПЭС"
	},
	sendMessage: {
		1 : 'Сообщение',
		0 : 'Паведамленне'
	},
	attachFiles: {
		0 : "Прымацаваць файлы",
		1 : "Прикрепить файлы"
	},
	inputPlaceholder: {
		0 : "Увядзіце паведамленне",
		1 : "Введите сообщение"
	},
	sendMessageTo: {
		1 : 'Отправить сообщение',
		0 : 'Адправіць паведамленне'
	},
	sendMessageFor: {
		1 : "Сообщение для ",
		0 : "Паведамленне для "
	},
	reOrgUser: {
		1 : "Сотрудник",
		0 : "Супрацоўнік"
	},
	user: {
		0 : "Карыстальнік",
		1 : "Пользователь"
	},
	linkLabel: {
		0 : "Націсніце для пераходу да дыялогу",
		1 : "Нажмите для перехода к диалогу"
	},
	inputWarning: {
		0 : "Увядзіце паведамленне або прымацуеце файлы.",
		1 : "Введите сообщение или прикрепите файлы."
	},
	historyRedirectAppeal: {
		1 : 'История перенаправлений',
		0 : 'Гісторыя перанакіраванняў'
	},
	addExecutorResult: {
		1 : 'Добавить',
		0 : 'Дадаць'
	},
	moreThan30Applicants: {
		1 : '30 и более заявителей',
		0 : '30 і больш заяўнікаў'
	},
	collectiveAppealsListId: {
		1 : 'Идентификатор',
		0 : 'Ідэнтыфікатар'
	},
	errorWithFileSignInCP: {
		1 : 'Ошибка при подписании файла, код ошибки ',
		0 : 'Памылка пры падпісанні файла, код памылкі '
	},
	errorWithTextSignInCP: {
		1 : 'Ошибка при подписании текста, код ошибки ',
		0 : 'Памылка пры падпісанні тэкста, код памылкі '
	},
	errorWithCPAccess: {
		1 : 'Ошибка доступа клиентского приложения. Проверьте, запущена ли у вас программа.',
		0 : 'Памылка доступу кліенцкага прыкладання. Праверце, ці запушчана ў вас праграма.'
	},
	onlyCyrillicErrorMessage: {
		1 : 'Поле должно содержать в себе более 1 символа на кириллице и начинаться с заглавной буквы. Также допускаются символы дефиса, апострофа и пробела если за ними идут буквы.',
		0 : 'Поле павінна ўтрымоўваць у сабе больш за 1 знака на кірыліцы і пачынацца з загалоўнай літары. Таксама дапушчаюцца знакі злучка, апострафа і прабелу калі за імі ідуць літары.'
	},
	takeIntoAccount: {
		1 : 'Принять к сведению',
		0 : 'Прыняць да ўвагі'
	},
	takeIntoAccountPopconfirm: {
		1 : 'Вы действительно хотите принять обращение к сведению?',
		0 : 'Вы сапраўды хочаце прыняць зварот да ведама?'
	},
	takeIntoAccountSuccess: {
		1 : 'Обращение успешно принято к сведению',
		0 : 'Зварот паспяхова прыняты да ўвагі'
	},
	takeIntoAccountFailure: {
		1 : 'Не удалось принять обращение к сведению. Пожалуйста, обратитесь к главному администратору',
		0 : 'Не ўдалося прыняць зварот да ведама. Калі ласка, звярніцеся да галоўнага адміністратара'
	},
	openAppealInNewTab: {
		1 : 'Открывать карточку обращения в новой вкладке',
		0 : 'Адкрываць картку звароту ў новай укладцы'
	},
	editAppealEmptyResult: {
		1 : "Обращение не было отредактировано, так как не было внесено новых данных.",
		0 : "Зварот не быў адрэдагаваны, не было ўнесена новых дадзеных."
	},
	accompanyingFileBtn: {
		1 : "Сгенерировать файл",
		0 : "Згенераваць файл"
	},
	attachOrDownload: {
		1 : "Сохранить файл на устройство или добавить в форму перенаправления?",
		0 : "Захаваць файл на прыладу або дадаць у форму перанакіравання?"
	},
	filesCountError: {
		0: "Нельга дадаваць больш {0} файлаў!",
		1: "Нельзя добавлять больше {0} файлов!"
	},
	phoneValidatorMessage: {
		1: 'Пожалуйста, введите только цифры и знак "+"',
		0: 'Калі ласка, увядзіце толькі лічбы і знак "+"'
	}, 
	Notice: {
		1: 'Примечание',
		0: 'Нататка'
	},
	NoticeFiles: {
		1: 'Файлы примечания',
		0: 'Файлы нататкі'
	},
	noticeTooltip: {
		1: 'Чтобы развернуть примечание нажмите на стрелку',
		0: 'Каб разгарнуць нататка націсніце на стрэлку'
	},
	applicationDeadline: {
		1: 'Срок исполнения обращения',
		0: 'Тэрмін выканання звароту'
	},
	reOrgAppealTerritory: {
		1: 'Место действия обращения',
		0: 'Месца дзеяння звароту'
	},
	reOrgAppealTerritoryPlaceholder: {
		1: 'Начните вводить место действия обращения',
		0: 'Пачніце ўводзіць месца дзеяння звароту'
	},
	reportForOrganization: {
		1: 'Отчет для организаций на контроле',
		0: 'Даклад для арганізацый на кантролі'
	},
	filesForOrganization: {
		1: 'Прикрепить файлы к отчету',
		0: 'Прымацаваць файлы да дакладу'
	},
	reportTextForOrganizationMessage: {
		1: 'Необходимо ввести отчет для организаций на контроле.',
		0: 'Неабходна ўвесці справаздачу для арганізацый на кантролі.'
	},
	reportForControlOrgSuccessCreate: {
		1: 'Отчет для организаций успешно создан',
		0: 'Справаздача для арганізацый паспяхова створана'
	},
	validateIdentificationNumberMessage: {
		1: 'Идентификационный номер введен некорректно',
		0: 'Ідэнтыфікацыйны нумар уведзены некарэктна'
	},
	enterIdentificationNumberMessage: {
		1: 'Введите идентификационный номер',
		0: 'Увядзіце ідэнтыфікацыйны нумар'
	},
	validatePhoneNumberMessage: {
		1: 'Номер телефона введен некорректно',
		0: 'Нумар тэлефона ўведзены некарэктна'
	},
	enterPhoneNumberMessage: {
		1: 'Введите номер телефона',
		0: 'Увядзіце нумар тэлефона'
	},
	incorrectNameValue: {
		1: 'Поле заполнено некорректно, для изменения данных перейдите во вкладку "Мой профиль" в личном кабинете',
		0: 'Поле запоўнена некарэктна, для змены дадзеных перайдзіце ва ўкладку "Мой профіль" у асабістым кабінеце'
	},
	error: {
		1: 'Ошибка',
		0: 'Памылка'
	},
	changesWereNotRecordedInTheDatabase: {
		1: 'Изменения не были зафиксированы в базе данных',
		0: 'Змены не былі зафіксаваны ў базе дадзеных'
	},
	addAppealNotice: {
		1: 'Добавить примечание',
		0: 'Дадаць нататку'
	},
	appealNoticeSuccessfullyChanged: {
		1: 'Примечание успешно изменено',
		0: 'Нататку паспяхова зменена'
	},
	editNoticeTooltip: {
		1: 'Нажмите, чтобы редактировать примечание',
		0: 'Націсніце, каб рэдагаваць нататку'
	},
	signer: {
		1 : 'Подписант:\n{0}',
		0 : 'Падпісант:\n{0}'
	},
	appealNoticeText: {
        1 : "Текст примечания",
        0 : "Тэкст нататкі"
    },
	noDataChange: {
		1 : "Данные не были изменены",
		0 : "Дадзеныя не былі зменены"
	},
	reOrgReceptionPersonsListEmptyMessage: {
		1 : "Лист лиц, проводящих личные приемы пуст. Пожалуйста, добавьте лиц, проводящих прием в Личном кабинете/Управление организацией/Лица, проводившие личный прием",
		0 : "Ліст асоб, якія праводзяць асабістыя прыёмы пусты. Калі ласка, дадайце асоб, якія праводзяць прыём у Асабістым кабінеце/Кіраванне арганізацыяй/Асобы, якія праводзілі асабісты прыём"
	}
}

export default i18n
